import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Typography, TypographyProps } from '@mui/material';
import React from 'react';

type Props = React.PropsWithChildren & TypographyProps;

export function ReadOnlyText(props: Props) {
  const { children, ...rest } = props;
  const semantic = useAtlasSemanticThemeTokens();
  return (
    <Typography {...rest} color={semantic.color.text.muted.value}>
      {children}
    </Typography>
  );
}
